var modSlider = function(){
    var scope = ".js-mod-slider";
    var sliderObj = null;
    ui.ready(
        scope,
        function($mod){
            var win = window;
            $(window).on('resize', function(){
                win = $(this);
                resize();
            });
            createSwiperInstance();

            function resize(){
                if($(win).width()<=768) {
                    $mod.find(scope+"__item-only-image--small").show();
                    $mod.find(scope+"__item-only-image--medium").hide();
                    $mod.find(scope+"__item-only-image--big").hide();
                    $mod.find(scope+"__item-only-image--bigXL").hide();
                    $mod.find(scope+"__item-only-image--bigXXL").hide();
                    $mod.find(scope+"__item-only-image--bigXXXL").hide();
                }else if ($(win).width()>=768 && $(win).width()<=991){
                    $mod.find(scope+"__item-only-image--small").hide();
                    $mod.find(scope+"__item-only-image--medium").show();
                    $mod.find(scope+"__item-only-image--big").hide();
                    $mod.find(scope+"__item-only-image--bigXL").hide();
                    $mod.find(scope+"__item-only-image--bigXXL").hide();
                    $mod.find(scope+"__item-only-image--bigXXXL").hide();
                }else if ($(win).width()>=992 && $(win).width()<=1439){
                    $mod.find(scope+"__item-only-image--small").hide();
                    $mod.find(scope+"__item-only-image--medium").hide();
                    $mod.find(scope+"__item-only-image--big").show();
                    $mod.find(scope+"__item-only-image--bigXL").hide();
                    $mod.find(scope+"__item-only-image--bigXXL").hide();
                    $mod.find(scope+"__item-only-image--bigXXXL").hide();
                }else if ($(win).width()>=1440 && $(win).width()<=1919){
                    $mod.find(scope+"__item-only-image--small").hide();
                    $mod.find(scope+"__item-only-image--medium").hide();
                    $mod.find(scope+"__item-only-image--big").hide();
                    $mod.find(scope+"__item-only-image--bigXL").show();
                    $mod.find(scope+"__item-only-image--bigXXL").hide();
                    $mod.find(scope+"__item-only-image--bigXXXL").hide();
                }else if ($(win).width()>=1920 && $(win).width()<=2560){
                    $mod.find(scope+"__item-only-image--small").hide();
                    $mod.find(scope+"__item-only-image--medium").hide();
                    $mod.find(scope+"__item-only-image--big").hide();
                    $mod.find(scope+"__item-only-image--bigXL").hide();
                    $mod.find(scope+"__item-only-image--bigXXL").show();
                    $mod.find(scope+"__item-only-image--bigXXXL").hide();
                }else{
                    $mod.find(scope+"__item-only-image--small").hide();
                    $mod.find(scope+"__item-only-image--medium").hide();
                    $mod.find(scope+"__item-only-image--big").hide();
                    $mod.find(scope+"__item-only-image--bigXL").hide();
                    $mod.find(scope+"__item-only-image--bigXXL").hide();
                    $mod.find(scope+"__item-only-image--bigXXXL").show();
                }
            }

            function createSwiperInstance(){
                if(sliderObj){
                    sliderObj.destroy(true);
                }
                sliderObj = new Swiper($mod.find(scope + '__slider').get(0), {
                    pagination: {
                        el: '.swiper-pagination',
                        type: 'bullets',
                        clickable: true,
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                    // AutoPlay
                    autoplay: {
                        delay: 7000,
                    },
                    speed: 1000,
                    watchSlidesProgress: true,
                    watchSlidesVisibility: true,
                    // Loop
                    loop: true,
                });
                resize();
            }
        }
    );

}();